import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResult } from "@app/shared/model/apiresult";
import { Guid } from "guid-typescript";
import { catchError, map } from 'rxjs/operators';
import { environment as env } from '@environments/environment'
import { throwError } from "rxjs";
import { IPersonEmail } from "../model/personemail";

@Injectable({ providedIn: 'root' })

export class PersonEmailService {
    constructor(private http: HttpClient) { }

    get(personId: Guid) {
        return this.http.get<ApiResult<IPersonEmail[]>>(env.apiUrl + 'PersonEmail/' + personId);
    }
    post(studentDocument: IPersonEmail) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'PersonEmail', studentDocument).pipe(catchError(this.handleError))
    }
    put(studentDocument: IPersonEmail) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'PersonEmail', studentDocument);
    }
    delete(id: Guid) {
        return this.http.delete<ApiResult<any>>(env.apiUrl + 'PersonEmail/' + id);
    }
    handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
}